/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: mUru5t19QSwF

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeSolutionsSectionCard.module.css"; // plasmic-import: mUru5t19QSwF/css

import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: ASrk5vWaGnLc/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicHomeSolutionsSectionCard__VariantMembers = {};
export type PlasmicHomeSolutionsSectionCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeSolutionsSectionCard__VariantsArgs;
export const PlasmicHomeSolutionsSectionCard__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeSolutionsSectionCard__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicHomeSolutionsSectionCard__ArgsType;
export const PlasmicHomeSolutionsSectionCard__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicHomeSolutionsSectionCard__OverridesType = {
  cardContent?: Flex__<"div">;
};

export interface DefaultHomeSolutionsSectionCardProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeSolutionsSectionCard__RenderFunc(props: {
  variants: PlasmicHomeSolutionsSectionCard__VariantsArgs;
  args: PlasmicHomeSolutionsSectionCard__ArgsType;
  overrides: PlasmicHomeSolutionsSectionCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"cardContent"}
      data-plasmic-override={overrides.cardContent}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.cardContent
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <React.Fragment>
            <div className={classNames(projectcss.all, sty.freeBox__zirLo)}>
              <h4
                className={classNames(
                  projectcss.all,
                  projectcss.h4,
                  projectcss.__wab_text,
                  sty.h4__yQaql
                )}
              >
                {"Graduate Medical Education Programs"}
              </h4>
              <Icon3Icon
                className={classNames(projectcss.all, sty.svg__sQoS)}
                role={"img"}
              />
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__uyYfI)}>
              <p
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.p__cnPtZ
                )}
              >
                {
                  "Make sure your institution stays compliant by integrating future-proof milestones & EPAs and using historical data to enhance your program. Optimize rotations without sacrificing quality and proactively manage your finances for better efficiency."
                }
              </p>
              <Button
                className={classNames("__wab_instance", sty.button__iw7VZ)}
                color={"sky"}
                size={"medium"}
              >
                {"LEARN MORE"}
              </Button>
            </div>
          </React.Fragment>
        ),
        value: args.children
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  cardContent: ["cardContent"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  cardContent: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeSolutionsSectionCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeSolutionsSectionCard__VariantsArgs;
    args?: PlasmicHomeSolutionsSectionCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomeSolutionsSectionCard__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicHomeSolutionsSectionCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeSolutionsSectionCard__ArgProps,
          internalVariantPropNames:
            PlasmicHomeSolutionsSectionCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeSolutionsSectionCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "cardContent") {
    func.displayName = "PlasmicHomeSolutionsSectionCard";
  } else {
    func.displayName = `PlasmicHomeSolutionsSectionCard.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeSolutionsSectionCard = Object.assign(
  // Top-level PlasmicHomeSolutionsSectionCard renders the root element
  makeNodeComponent("cardContent"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicHomeSolutionsSectionCard
    internalVariantProps: PlasmicHomeSolutionsSectionCard__VariantProps,
    internalArgProps: PlasmicHomeSolutionsSectionCard__ArgProps
  }
);

export default PlasmicHomeSolutionsSectionCard;
/* prettier-ignore-end */
